export default __webpack_public_path__ + "static/media/blue-heron.a5163c66.jpg";